import {Validator} from '@/type/validation/result';
import {半角カナ禁止} from '@/type/validation/validator';

export interface 棚卸差数在庫場所結果型 {
    棚卸差数在庫場所一覧: 棚卸差数在庫場所型[];
    所属在庫場所: 棚卸差数在庫場所型;
}

export interface 棚卸差数在庫場所型 {
    部署コード: string;
    部署名: string;
}

export interface 棚卸差数棚卸年月日型 {
    棚卸日: Date;
}

export interface 棚卸差数結果型 {
    棚卸差数一覧: 棚卸差数型[];
    アラートメッセージ: string;
}

export interface 棚卸差数型 {
    商品コード: string;
    棚名: string;
    棚番号: string;
    メーカー名: string;
    商品名: string;
    有効期限: Date;
    在庫区分: string;
    規格容量: string;
    マイナス理論在庫: number;
    理論在庫: number;
    棚卸在庫: number;
    差数: number;
    入数: number;
    単位: string;
    商品区分: string;
    使用区分: string;
}

export interface 棚卸差数検索依頼型 {
    部署コード: string;
    検索棚卸年月日: Date;
    表示対象差数有無区分: string;
    商品名カナ検索文字列: string;
    メーカー名検索文字列: string;
    検索対象商品区分: string | null;
    検索対象使用区分: string | null;
    棚名検索文字列: string;
    棚番号検索文字列: string;
    並順区分検索条件: string;
}

export const 棚卸差数検索条件型バリデータ一覧: Validator[] = [
    {
        name: '商品名カナ検索文字列',
        constraints: [
            {method: 半角カナ禁止, message: '商品名カナに半角カナが含まれています'},
        ],
    },
];
